import { render } from "./NatProjects.vue?vue&type=template&id=0258b4b8"
import script from "./NatProjects.vue?vue&type=script&lang=js"
export * from "./NatProjects.vue?vue&type=script&lang=js"
script.render = render

export default script